function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PreviewMedia from "./PreviewMedia";

var PreviewHeader = function (_Component) {
    _inherits(PreviewHeader, _Component);

    function PreviewHeader() {
        var _temp, _this, _ret;

        _classCallCheck(this, PreviewHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderMedia = function () {
            var _this$props = _this.props,
                mediaType = _this$props.mediaType,
                mimeType = _this$props.mimeType,
                imageWidth = _this$props.imageWidth,
                imageHeight = _this$props.imageHeight;


            if (!mediaType) {
                return false;
            }

            var metadata = [];

            metadata.push({
                "name": "mediaType",
                "label": "Media"
            });

            metadata.push({
                "name": "mimeType",
                "label": "MIME type"
            });

            if (mediaType === "image") {

                metadata.push({
                    "label": "Dimensions",
                    "value": imageWidth + "x" + imageHeight
                });
            }

            return React.createElement(
                "div",
                null,
                React.createElement(
                    "ul",
                    { className: "field__metadata" },
                    metadata.map(_this.renderMeta)
                ),
                React.createElement(PreviewMedia, { formData: { media: _this.props } })
            );
        }, _this.renderMeta = function (meta, index) {
            var name = meta.name,
                label = meta.label;


            var value = meta.value || _this.props[name];

            if (!value) {
                return false;
            }

            return React.createElement(
                "li",
                { className: "field__meta", key: index },
                React.createElement(
                    "b",
                    { className: "meta__label" },
                    label
                ),
                " ",
                React.createElement(
                    "i",
                    { className: "meta__value" },
                    value
                )
            );
        }, _this.renderMetadata = function () {
            var _this$props2 = _this.props,
                uniqueId = _this$props2.uniqueId,
                parentId = _this$props2.parentId,
                locale = _this$props2.locale,
                status = _this$props2.status,
                createdAt = _this$props2.createdAt,
                updatedAt = _this$props2.updatedAt;


            var metadata = [{
                "name": "uniqueId",
                "label": "uniqueId"
            }, {
                "name": "parentId",
                "label": "parentId"
            }, {
                "name": "locale",
                "label": "Locale"
            }, {
                "name": "status",
                "label": "Status"
            }, {
                "name": "createdAt",
                "label": "Created at"
            }, {
                "name": "updatedAt",
                "label": "Updated at"
            }];

            return React.createElement(
                "ul",
                { className: "field__metadata" },
                metadata.map(_this.renderMeta)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PreviewHeader.prototype.render = function render() {
        var _props = this.props,
            documentType = _props.documentType,
            mediaType = _props.mediaType,
            imageUrl = _props.imageUrl,
            name = _props.name,
            title = _props.title,
            description = _props.description,
            language = _props.language,
            locale = _props.locale,
            status = _props.status,
            createdAt = _props.createdAt,
            updatedAt = _props.updatedAt;


        var fieldLabel = void 0,
            fieldType = void 0;

        if (documentType) {
            fieldLabel = documentType;
            fieldType = "document";
        }

        if (mediaType) {
            fieldLabel = mediaType;
            fieldType = "media";
        }

        if (!fieldType) {
            fieldLabel = name || "untitled";
            fieldType = "schema";
        }

        return React.createElement(
            "header",
            { className: "admin-preview__field  field--header" },
            React.createElement(
                "h3",
                { className: "field__label" },
                fieldLabel,
                " ",
                React.createElement(
                    "em",
                    { className: "field__type" },
                    fieldType
                )
            ),
            React.createElement(
                "h1",
                { className: "field__title" },
                title
            ),
            this.renderMedia(),
            this.renderMetadata()
        );
    };

    return PreviewHeader;
}(Component);

export default PreviewHeader;